import { render, staticRenderFns } from "./pengajuan.vue?vue&type=template&id=03f7da28&scoped=true&"
import script from "./pengajuan.vue?vue&type=script&lang=js&"
export * from "./pengajuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7da28",
  null
  
)

export default component.exports